import { usePathname } from "next/navigation";

export const useSubscribeDialogFeature = () => {
  const pathname = usePathname();
  let feature = "others";
  if (pathname.includes("screener")) {
    feature = "screener";
  } else if (pathname.includes("winwingpt")) {
    feature = "winwingpt";
  }
  return { feature };
};
